import axios from "axios"

export const getTokenByTicktAndCliant = async (tikite: any, cliantId: any) => {
  return await axios.post(`${process.env.REACT_APP_AUTHPATH}/exchangeToken`, {
    ticket: tikite,
    clientId: cliantId ? cliantId : '837fa681-2d7d-4c21-9171-cf7ac168850a'
  })
}